
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-to-gif-converter",
      function () {
        return require("private-next-pages/video-to-gif-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-to-gif-converter"])
      });
    }
  